/**
 * Created by shubham on 13/6/18.
 */

import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from '../../shared/services/http.service';
import { SessionHandler } from '../../shared/services/session-handler.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { MdDialog } from '@angular/material';
import { DialogComponent } from '../../dialog/dialog.component';
import { CSVErrorDialogComponent } from '../../dialog/dialog.component';
import { CommonService } from '../../shared/services/common.service';
import { APPCONFIG } from '../../config';
import { FileUploadListPage } from "../fileUploadList-datatable/fileUploadList-page";
import { FileUploadListDashboardResultService } from '../fileUploadListDashboardResultService';
import {TranslateService} from 'ng2-translate';

@Component({
    selector: 'fileUploadList',
    template: require('./fileUploadList.component.html')
})
export class FileUploadListComponent {

    @ViewChild(DatatableComponent) table: DatatableComponent;
    dialogRef;
    userDetails:any;
    page = new FileUploadListPage();
    tableRows :any = [];
    filters:any = {};
    rows:any;
    uploadList: any;
    temp = [];
    showTable:boolean = true;
    isSystemAdmin:boolean = false;
    isBUManager:boolean = false;
    isRegionalAdmin:boolean = false;
    isServiceOwner:boolean = false;
    isTradePartner:boolean = false;
    isSubUser:boolean = false;
    dataTableMessage = {'selectedMessage':'','totalMessage':''};

    constructor(private router: Router, private httpService:HttpService, private sessionHandler:SessionHandler, public dialog: MdDialog,
                private serverResultsService: FileUploadListDashboardResultService, private commonService: CommonService, private translate: TranslateService) {

        this.page.pageNumber = 0;
        this.page.size = 20;
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));

        if(this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0){
            if(this.userDetails.roleCode.includes(APPCONFIG.systemAdmin)) {
                this.isSystemAdmin = true;
            } else if(this.userDetails.roleCode.includes(APPCONFIG.BUManager)) {
                this.isBUManager = true;
            } else if(this.userDetails.roleCode.includes(APPCONFIG.regionalAdmin)) {
                this.isRegionalAdmin = true;
            } else if(this.userDetails.roleCode.includes(APPCONFIG.serviceOwner)) {
                this.isServiceOwner = true;
            } else if(this.userDetails.roleCode.includes(APPCONFIG.tradePartner)) {
                this.isTradePartner = true;
            } else if(this.userDetails.roleCode.includes(APPCONFIG.subuser)) {
                this.isSubUser = true;
            }
        } else {
            this.httpService.noUserError();
        }

        this.filters['offSet'] = this.page.pageNumber * this.page.size;
        this.filters['limit'] = this.page.size;
        if(this.isSystemAdmin || this.isBUManager){
            this.getFileUploadList(this.filters);
        } else{
            this.showTable = false;
        }
    }

    public getFileUploadList(filter){
        this.httpService.getRequest("dataUploadOperations/v1/userMigration/list?limit="+filter.limit+"&offset="+filter.offSet).subscribe(
            res => { this.saveFileUploadList(res, filter); },
            err => { this.httpService.onEnd(); }
        );
    }

    public saveFileUploadList = function(res, filter){
        if(res.errorStatus == 'Fail') {
            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = 'data_pull_fail';
        } else {
            if(res && Object.keys(res).length > 0 ){
                this.uploadList = res;
                this.rows = [];
                this.rows['offset'] = res.offset;

                if(this.uploadList.list) {
                    let totalCount = 0;
                    if (parseInt(res.offset) == 0) {
                        localStorage.setItem('totalCount', res.totalCount);
                        totalCount = parseInt(res.totalCount);
                    } else {
                        totalCount = parseInt(localStorage.getItem('totalCount'));
                    }

                    this.rows['totalCount'] = totalCount;
                    for (let data in this.uploadList.list) {
                        this.rows[data] = {};
                        this.rows[data]['id'] = this.uploadList.list[data]['id'];
                        this.rows[data]['type'] = this.uploadList.list[data]['type'];

                        if(this.uploadList.list[data]['countryName']){
                            this.rows[data]['countryName'] = this.uploadList.list[data]['countryName'];
                        }

                        if(this.uploadList.list[data]['businessUnitName']){
                            this.rows[data]['businessUnitName'] = this.uploadList.list[data]['businessUnitName'];
                        }

                        this.rows[data]['includesHeader'] = this.uploadList.list[data]['includesHeader'];
                        this.rows[data]['csvName'] = this.uploadList.list[data]['csvName'];
                        this.rows[data]['csvUrl'] = this.uploadList.list[data]['csvUrl'];
                        this.rows[data]['status'] = this.uploadList.list[data]['status'];

                        this.rows[data]['error'] = this.uploadList.list[data]['error'];
                        if(this.uploadList.list[data]['error'] == true){
                            this.rows[data]['message'] = this.uploadList.list[data]['message'];
                        }

                        this.rows[data]['uploadBy'] = this.uploadList.list[data]['uploadBy'];
                        this.rows[data]['uploadedAt'] = this.uploadList.list[data]['uploadedAt'];
                    }
                    this.showTable = true;
                    this.temp = this.rows;
                } else{
                    this.showTable = false;
                }

                let finalRows = [];
                for(let f in this.rows){
                    if(f != 'offset' && f !='totalCount' && this.rows[f]){
                        finalRows.push(this.rows[f]);
                    }
                    if(f == 'offset'){
                        finalRows['offset'] = this.rows['offset'];
                    }
                    if(f == 'totalCount'){
                        finalRows['totalCount'] = this.rows['totalCount'];
                    }
                }
                this.rows = finalRows;
                this.setPage({ offset: this.rows['offset']/this.page.size },finalRows,filter);
                this.httpService.onEnd();
            }
        }
    }

    /**
     * Populate the table with new data based on the page number
     * @param page The page to select
     */
    public setPage(pageInfo,rows,filter){
        this.page.pageNumber = pageInfo.offset;
        if(rows.length != 0){
            this.serverResultsService.getResults(this.page,rows).subscribe(pageData => {
                this.page = pageData.page;
                this.tableRows = pageData.data;
                if(!filter){
                    if(Object.keys(this.tableRows).length == 0 || !this.tableRows[0]['status']){
                        this.filters['offSet'] = this.page.pageNumber * this.page.size;
                        this.getFileUploadList(this.filters);
                    }
                }
            });
        } else {
            this.tableRows = [];
            this.page.totalElements = rows.length;
        }
    }

    public showErrorMsg(msg){
        this.dialogRef = this.dialog.open(CSVErrorDialogComponent);
        this.dialogRef.componentInstance.msg = msg;
    }

    ngOnInit(){
        this.translate.get('total').subscribe((res: string) => {
            this.dataTableMessage.totalMessage=res;
        });
        this.translate.get('selected').subscribe((res: string) => {
            this.dataTableMessage.selectedMessage=res;
        });
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/file-upload/fileUploadList/fileUploadList.component.ts